import { render, staticRenderFns } from "./ClientGlobal.vue?vue&type=template&id=df9e3bc6&"
import script from "./ClientGlobal.vue?vue&type=script&lang=js&"
export * from "./ClientGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports